import axios from 'axios'
import { User } from '../../interfaces'

export const createUser = (user: User) => {
  return axios.post('/data/sadarbības_partnera_personas', user)
}
